import colorTokens from '../../design-tokens/ui-colors.json';

export const UI_COLORS = Object.freeze(colorTokens);

export function getUiColor(group, name) {
    const groupColors = UI_COLORS[group];
    if (!groupColors || !groupColors[name]) {
        throw new Error(`Unknown UI color token: ${group}.${name}`);
    }

    return groupColors[name];
}
